import "./style.scss";

import { AppContext } from "..";
import { useContext } from "react";

const Count = ({ count, id }) => {
  const { increaseValue, decreaseValue, changeValue } = useContext(AppContext);

  return (
    <div className="product__count">
      <div className="count">
        <div className="count__box">
          <input
            onChange={(e) => {
              changeValue(id, +e.target.value);
            }}
            type="number"
            className="count__input"
            min="1"
            max="100"
            value={count}
          />
        </div>
        <div className="count__controls">
          <button
            type="button"
            className="count__up"
            onClick={() => {
              increaseValue(id);
            }}
          >
            <img src="./img/icons/icon-up.svg" alt="Increase" />
          </button>
          <button
            type="button"
            className="count__down"
            onClick={() => {
              decreaseValue(id);
            }}
          >
            <img src="./img/icons/icon-down.svg" alt="Decrease" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Count;
